import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Box,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  Slide,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { postContactUs } from "../services/contactusService";

const initialFormData = {
  firstName: "",
  //lastName: "",
  email: "",
  phoneNumber: "",
  companyName: "",
  dealerId: "",
  ctype:"",
  comments: "",
  consent: false,
};

export const ContactUsDialog = ({ open, onClose, initialValues }) => {
  const [submitting, setSubmitting] = useState(false);

  const [snackbarOpen, setSnackbarOpen] = useState(false);

//console.log("ContactUs Dialog : ",initialValues)
  const handleClose = () => {
    formik.resetForm();
    onClose();
  };
  const handleSnackbarClose = () => setSnackbarOpen(false);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: Yup.object({
      firstName: Yup.string().required("Full Name is required"),
      // lastName: Yup.string(),
      email: Yup.string()
        .email("Invalid email format")
        .required("Email is required"),
      phoneNumber: Yup.string(),
      companyName: Yup.string().required("Company Name is required"),
      dealerId: Yup.string(),
      ctype: Yup.string().required("Type selection is required"),
      comments: Yup.string().required("Comments are required"),
      consent: Yup.boolean().oneOf([true], "Consent is required"),
    }),
    onSubmit: (values) => {
      setSubmitting(true);
      console.log(values);
      postContactUs(values).then(res=>{
        console.log(res);
        setSnackbarOpen(true);
        setSubmitting(false);
        handleClose();
      }).catch(err =>{
        setSubmitting(false);
        console.log(err);
      })

    },
  });

  return (
    <>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm" TransitionComponent={Slide}
        TransitionProps={{ direction: "up" }}>
        <DialogTitle>Contact Us</DialogTitle>
        <DialogContent>
          <Box component="form" onSubmit={formik.handleSubmit}>
          <Box display="flex" gap={2} mt={2}>
              <TextField
                fullWidth
                label="Dealer Name"
                name="companyName"
                value={formik.values.companyName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled
                slotprops={{
                  input: {
                    readOnly: true,
                  },
                }}
                error={
                  formik.touched.companyName &&
                  Boolean(formik.errors.companyName)
                }
                helperText={
                  formik.touched.companyName && formik.errors.companyName
                }
              />
              <TextField
                fullWidth
                label="Dealer Id"
                name="dealerId"
                value={formik.values.dealerId}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled
                slotprops={{
                  input: {
                    readOnly: true,
                  },
                }}
                error={
                  formik.touched.dealerId && Boolean(formik.errors.dealerId)
                }
                helperText={
                  formik.touched.dealerId && formik.errors.dealerId
                }
              />
            </Box>
            <Box display="flex" gap={2} mt={2}>
              <TextField
                fullWidth
                label="Full Name"
                name="firstName"
                value={formik.values.firstName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={submitting}
                error={
                  formik.touched.firstName && Boolean(formik.errors.firstName)
                }
                helperText={formik.touched.firstName && formik.errors.firstName}
              />
              {/* <TextField
                fullWidth
                label="Last Name"
                name="lastName"
                value={formik.values.lastName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.lastName && Boolean(formik.errors.lastName)
                }
                helperText={formik.touched.lastName && formik.errors.lastName}
              /> */}
            </Box>

            <Box display="flex" gap={2} mt={2}>
              <TextField
                fullWidth
                label="Email"
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={submitting}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
              />
              <TextField
                fullWidth
                label="Phone Number"
                name="phoneNumber"
                value={formik.values.phoneNumber}
                disabled={submitting}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </Box>

          
            <TextField
              fullWidth
              select
              label="Type"
              name="ctype"
              value={formik.values.ctype}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              disabled={submitting}
              error={formik.touched.ctype && Boolean(formik.errors.ctype)}
              helperText={formik.touched.ctype && formik.errors.ctype}
              sx={{ mt: 2 }}
            >
              <MenuItem value="Agreements">Agreements</MenuItem>
              <MenuItem value="PotentialClaims">Potential Claims</MenuItem>
              <MenuItem value="Feedback">Feedback</MenuItem>
              <MenuItem value="SomethingElse">Something Else</MenuItem>
            </TextField>

            <TextField
              fullWidth
              multiline
              rows={4}
              label="How can we help you?"
              name="comments"
              value={formik.values.comments}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              disabled={submitting}
              error={formik.touched.comments && Boolean(formik.errors.comments)}
              helperText={formik.touched.comments && formik.errors.comments}
              sx={{ mt: 2 }}
            />

            <FormControlLabel
              control={
                <Checkbox
                  name="consent"
                  checked={formik.values.consent}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={submitting}
                />
              }
              label="I consent to be contacted by JB Warranties via SMS, phone call or email."
              sx={{ mt: 2 }}
            />
            {formik.touched.consent && formik.errors.consent && (
              <Typography color="error" variant="caption">
                {formik.errors.consent}
              </Typography>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" disabled={submitting}>
            Cancel
          </Button>
          <Button onClick={formik.handleSubmit} color="primary" disabled={submitting}>
            Submit
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        message="Thank you for contacting us!"
      />
    </>
  );
};
